// import "./src/styles/style.scss";

import React from 'react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import CookieConsent from 'react-cookie-consent'

import { UserProvider } from './src/context/UserContext'

export const wrapRootElement = ({ element }) => (
    <GoogleReCaptchaProvider reCaptchaKey="6LcNYPIlAAAAAM7owApjPNt0qqCtA68I9Rv6Pt6x">
        <UserProvider>
            {element}
            <CookieConsent
                enableDeclineButton
                location="bottom"
                buttonText="I accept"
                // buttonClasses="button--rounded"
                declineButtonText="I decline"
                cookieName="myAwesomeCookieName2"
                style={{
                    background: 'rgba(45, 41, 40, 0.85)',
                    backdropFilter: 'blur(10px)',
                    '-webkit-filter': 'blur("8px")',
                    // borderTop: "5px solid #fdfe00",
                    padding: '20px 20px'
                }}
                buttonStyle={{
                    background: '#fdfe00',
                    fontSize: '16px',
                    padding: '1rem 2rem',
                    fontFamily: 'Lexend'
                }}
                declineButtonStyle={{
                    background: 'white',
                    color: 'black',
                    fontFamily: 'Lexend',
                    fontSize: '16px',
                    padding: '1rem 2rem'
                }}
                expires={150}
            >
                <p>
                    We use different types of cookies to enhance the user
                    experience. Some cookies are placed by third party services
                    that appear on our pages.
                </p>
                <p>
                    You can anytime change or withdraw your consent from the
                    cookie declaration on our website.
                </p>
            </CookieConsent>
        </UserProvider>
    </GoogleReCaptchaProvider>
)
